import React from 'react';
import './feature.scss';
import {
    products,
    productsIntroEng,
    productsIntroHun,
    productsTitle
} from "../demo_page/content";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

class Feature extends React.Component {
    componentDidMount() {
        setTimeout(function () {
            document.querySelector(".loader-wrapper").style = "display: none";
        }, 2000);
    }
    render() {
        // Getting Dynamic Features Data
        const isEng = this.props.language && this.props.language === 'ENG';
        let linksMarkup = products.map((link, i) => {
            return (
                <div className="col-lg-4 col-md-6 product-card" key={i}>
                    <div className="review-box">
                        <div className="product-icon" style={{background: link.color, color: '#fff'}}>
                            <FontAwesomeIcon icon={link.icon} />
                        </div>
                        {/*<img src={link.imgUrl} alt="review" className="img-fluid" />*/}
                        <h5>{isEng ? link.labelEng : link.labelHun}</h5>
                        <div className="review-message">
                            <p dangerouslySetInnerHTML={{__html: isEng ? link.descEng : link.descHun}}/>
                        </div>
                    </div>
                </div>
            );
        });

        return (
        <section>
            <div className="products-personalized container" id={'products'}>
                <div className="row">
                    <h2 className="title">{isEng ? productsTitle.eng : productsTitle.hun}</h2>
                    <p className="" dangerouslySetInnerHTML={{__html: isEng ? productsIntroEng : productsIntroHun}}/>
                </div>
            </div>
            <div className="review-block">
                <div className="container">
                    <div className="row margin-bottom">
                        {linksMarkup}
                    </div>
                </div>
            </div>
        </section>
        );
    }
}

export default Feature;



// WEBPACK FOOTER //
// ./src/components/feature.js